import { Link } from 'gatsby';
import React, { memo } from 'react';
import * as styles from './TopNavbar.module.css';
import Avatar from '../shared/Avatar';
import Logo from '../shared/Logo';

const TopNavbar = () => (
  <div className={`${styles.navbar}`}>
    <div className="container px-12">
      <Link to="/" className="flex items-center hover:no-underline">
        <Logo size="40px" />
        <h3 className="text-2xl ">YES | Resume Builder</h3>
      </Link>

      <Avatar className="ml-8" />
    </div>
  </div>
);

export default memo(TopNavbar);
